import React from 'react';
import { trialChargeDateLabel } from '../utils/trialChargeDate';

/** #1360 — One line above the Stripe form for signed-in users converting mid-trial. */
export default function TrialChargeLine({ subscription, style }) {
  const date = trialChargeDateLabel(subscription);
  if (!date) return null;
  return (
    <p
      data-testid="trial-charge-line"
      style={{ fontSize: 13.5, lineHeight: 1.5, color: '#5a4d2a', fontWeight: 600, textAlign: 'center', margin: '0 0 14px', ...style }}
    >
      Your card is charged on {date}, when your free trial ends.
    </p>
  );
}
